import 'leaflet';

const svgIcon = L.divIcon({
  html: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 603.84 818.76" xml:space="preserve"><path d="M301.92 0C135.17 0 0 135.18 0 301.92s301.92 516.84 301.92 516.84 301.92-350.11 301.92-516.85S468.67 0 301.92 0zm0 363.38c-43.078 0-78-34.922-78-78s34.922-78 78-78c43.094 0 78 34.922 78 78 0 43.082-34.906 78-78 78z"/></svg>`,
  className: '',
  iconSize: [32, 42],
  iconAnchor: [16, 42],
});

$('.js-leaflet').each((index, element) => {
  const $leaflet = $(element);
  const $leafletMarkers = $leaflet.find('.js-leaflet-marker');

  const map = L.map(element, {
    center: [
      Number($leaflet.attr('data-lat')),
      Number($leaflet.attr('data-lng')),
    ],
    zoom: Number($leaflet.attr('data-zoom')),
  });

  L.TileLayer.Custom = L.TileLayer.extend({
    createTile: function (coords, done) {
      const tile = L.TileLayer.prototype.createTile.call(this, coords, done);
      const container = document.createElement('div');
      container.appendChild(tile);
      return container;
    },
  });

  L.tileLayer.custom = function () {
    return new L.TileLayer.Custom(...arguments);
  };

  L.tileLayer
    .custom(
      'https://tile.openstreetmap.org/{z}/{x}/{y}.png', // https://api.maptiler.com/maps/basic-v2/{z}/{x}/{y}.png?key=csDKXek3qFO7gI6UaWdL
      {
        // tileSize: 512,
        // zoomOffset: -1,
        minZoom: 1,
        maxZoom: 19,
        attribution:
          '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        // attribution:
        //   '<a href="https://www.maptiler.com/copyright/" target="_blank">&copy; MapTiler</a> | <a href="https://www.openstreetmap.org/copyright" target="_blank">&copy; OpenStreetMap contributors</a>',
      }
    )
    .addTo(map);

  const markers = L.featureGroup();

  const triggers = [];

  $leafletMarkers.each((index, element) => {
    const $leafletMarker = $(element);
    const $leafletTrigger = $($leafletMarker.attr('data-trigger'));
    const marker = L.marker(
      [
        Number($leafletMarker.attr('data-lat')),
        Number($leafletMarker.attr('data-lng')),
      ],
      { icon: svgIcon }
    ).bindPopup($leafletMarker.html(), {
      offset: L.point(0, -30),
    });
    markers.addLayer(marker);
    triggers.push([$leafletTrigger, marker]);
  });

  markers.addTo(map);

  map.fitBounds(markers.getBounds());

  // todo: this can get cleaned up.

  $(window).on('scroll', function () {
    const middleOfScreen = $(window).scrollTop() + $(window).height() / 2;
    triggers.forEach(([trigger, marker]) => {
      if (
        trigger.offset().top < middleOfScreen &&
        trigger.offset().top + trigger.height() > middleOfScreen
      ) {
        marker.openPopup();
        L.DomUtil.addClass(marker._icon, 'leaflet-marker-active');
      } else {
        marker.closePopup();
        L.DomUtil.removeClass(marker._icon, 'leaflet-marker-active');
      }
    });
  });
});
